import { render, staticRenderFns } from "./BottomNavigation.vue?vue&type=template&id=04df1755"
import script from "./BottomNavigation.vue?vue&type=script&lang=ts"
export * from "./BottomNavigation.vue?vue&type=script&lang=ts"
import style0 from "./BottomNavigation.vue?vue&type=style&index=0&id=04df1755&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports